/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Component representing the footer of the application.
 * @author Tom Verschoore de la Houssaije

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["footer[_ngcontent-%COMP%]{position:absolute;bottom:0;left:0;right:0;background-color:#f8f9fa;text-align:center}"];
export { styles as styles };
